import type { AssessmentWelcome } from '@assessments/shared'
import { Button } from '@/components/ui/button'
import { RichText } from '@/components/ui/RichText'

export interface WelcomePageProps {
  welcome: AssessmentWelcome | null
  onProceed: () => void
}

/** Renders nothing when no welcome content is authored, so the respondent is never blocked. */
export function WelcomePage({ welcome, onProceed }: WelcomePageProps) {
  if (!welcome || (!welcome.heading && !welcome.body)) return null

  return (
    <main className="mx-auto max-w-2xl px-4 py-10">
      {welcome.heading && (
        <h1 className="mb-4 text-[28px] font-semibold tracking-tight text-body">
          {welcome.heading}
        </h1>
      )}
      <RichText html={welcome.body} className="mb-8 text-base" />
      <Button onClick={onProceed}>Continue to the assessment</Button>
    </main>
  )
}
